import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'does_fac_continuously_monitor_maintain_specific_regulated_indoor'

export const dataPointDefinition = {
  retracedId: 'does_fac_continuously_monitor_maintain_specific_regulated_indoor',
  name: 'Does the facility continuously monitor and maintain a specific regulated indoor temperature?',
  description:
    'Regulated indoor temperature means that temperature in the entire indoor space/ in all indoor spaces of the facility where workers are present is maintained at a specific temperature or within a specific temperature range. The facility may decide to maintain different temperature levels in different',
  meta: {
    slcpMeta: {
      key: 'hs-gen-20',
      number: 'HS-GEN-6',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-gen-20', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31240,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
